import styled from "styled-components"

import Card from "@irati/ui/src/Layout/Card"
import padding from "@irati/ui/src/global/padding"

import {minWidthMedia} from "@irati/ui/src/global/media"
import {Hr} from "@irati/ui/src/Layout"

export const ExtraPaddingCard = styled(Card)`
  margin-top: ${padding.small};

  ${minWidthMedia.tablet`
    padding: ${padding.base} ${padding.large};
    margin-top: ${padding.base};
  `}
`

export const TopHr = styled(Hr)`
  margin-bottom: 10px;
`

export const BottomHr = styled(Hr)`
  margin: 10px 0 30px 0;
`
